module.exports = __webpack_public_path__ + "assets/dashboard_icon.9ba5ef2b.svg";